// queries.js

import { gql } from "@apollo/client";

export const GET_USERS_QUERY = gql`
  query GetUsers {
    users {
      email
      role
      client {
        name
        surname
      }
    }
  }
`;
